import type { EmailOtpType } from "@supabase/supabase-js";

import { POST_AUTH_DEFAULT } from "./safe-next";

/** Tuple form — exported for `z.enum(EMAIL_OTP_TYPE_VALUES)` consumers (the
 *  /auth/callback POST handler's request schema). `as const satisfies` keeps
 *  the values readonly-literal-typed AND verifies at compile-time that every
 *  value is a real `EmailOtpType`. */
export const EMAIL_OTP_TYPE_VALUES = [
  "signup",
  "invite",
  "recovery",
  "email_change",
  "magiclink",
  "email",
] as const satisfies readonly EmailOtpType[];

/** Set form for `.has(x)` membership checks on a raw string (the
 *  /auth/confirm page validates the `type` searchParam this way before
 *  rendering the click-to-confirm form). Single source of truth shared
 *  with the POST handler's Zod enum — if either drifts, one accepts
 *  values the other rejects. */
export const EMAIL_OTP_TYPES: ReadonlySet<EmailOtpType> = new Set(
  EMAIL_OTP_TYPE_VALUES,
);

/** Per-type default landing path used when the email link carries no `next`
 *  parameter. The legacy GET-based flow threaded `next=/auth/update-password`
 *  via `resetPasswordForEmail`'s `redirectTo`; the click-to-confirm email
 *  templates (#683) point straight at /auth/confirm and CARRY NO `next` —
 *  recovery would otherwise land users on the dashboard instead of the
 *  password-reset form. Add per-type destinations here; missing entries
 *  fall through to `POST_AUTH_DEFAULT`. */
export const TYPE_DEFAULT_NEXT: Partial<Record<EmailOtpType, string>> = {
  recovery: "/auth/update-password",
};

export function defaultNextForType(type: EmailOtpType): string {
  return TYPE_DEFAULT_NEXT[type] ?? POST_AUTH_DEFAULT;
}
